import * as constants from './constants'

export const createVehicle = (tag, make, model, color, country, state) => ({
    type: constants.CREATE_VEHICLE,
    tag,
    make,
    model,
    color,
    country,
    state,
})

export const removeVehicle = vehicle => ({
    type: constants.REMOVE_VEHICLE,
    vehicle,
})
